import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-menu" };
const _hoisted_4 = { class: "float-end" };
const _hoisted_5 = { class: "form-contents" };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "clearfix" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_9 = { class: "clearfix" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_11 = { class: "input-group top_search" };
const _hoisted_12 = { class: "input-group-btn" };
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_14 = { class: "checkbox-wrapper" };
const _hoisted_15 = { class: "col-xs-12 col-sm-12" };
const _hoisted_16 = { class: "card bg-white data-grid detached overflow-x-auto" };
const _hoisted_17 = { class: "table table-hover table-fixed bottom0 pw100" };
const _hoisted_18 = { class: "hidden-sm" };
const _hoisted_19 = { class: "text-center hidden-sm" };
const _hoisted_20 = { class: "hidden-sm" };
const _hoisted_21 = { key: 0 };
const _hoisted_22 = { class: "data-grid-footer clearfix detached pw100" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_alert = _resolveComponent("b-alert");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_button_group = _resolveComponent("b-button-group");
    const _component_b_pagination = _resolveComponent("b-pagination");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "form-title" }, [
                _createElementVNode("h2", null, "\r\n\t\t\t\t\tApplications\r\n\t\t\t\t")
            ], -1 /* CACHED */)),
            _cache[7] || (_cache[7] = _createTextVNode()),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_router_link, { to: { name: 'application' } }, {
                        default: _withCtx(() => [
                            _createVNode(_component_b_button, { variant: "primary" }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                        _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Add Application", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ])
            ])
        ]),
        _cache[30] || (_cache[30] = _createTextVNode()),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_b_alert, {
                            variant: "primary",
                            dismissible: "",
                            modelValue: _ctx.showInfoMessage,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.showInfoMessage) = $event))
                        }, {
                            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\tYou can configure application and integration accounts that interact with the PowerShield Battery Monitoring API here.\r\n\t\t\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ])
                ]),
                _cache[28] || (_cache[28] = _createTextVNode()),
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _cache[10] || (_cache[10] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_12, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, [...(_cache[9] || (_cache[9] = [
                                        _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                    ]))])
                            ])
                        ])
                    ]),
                    _cache[12] || (_cache[12] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_b_form_checkbox, {
                                id: "includeArchived",
                                modelValue: _ctx.query.includeDeleted,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.includeDeleted) = $event)),
                                size: "lg"
                            }, {
                                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\tShow archived\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue"])
                        ])
                    ])
                ]),
                _cache[29] || (_cache[29] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("table", _hoisted_17, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _cache[13] || (_cache[13] = _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }, null, -1 /* CACHED */)),
                                    _cache[14] || (_cache[14] = _createTextVNode()),
                                    _createElementVNode("th", null, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'ApplicationName', title: 'Name' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _cache[15] || (_cache[15] = _createTextVNode()),
                                    _createElementVNode("th", _hoisted_18, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'WhenLastActive', title: 'Last Active' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ])
                                ])
                            ]),
                            _cache[25] || (_cache[25] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        class: _normalizeClass({ 'deleted': item.whenDeleted })
                                    }, [
                                        _createElementVNode("td", _hoisted_19, [
                                            _createVNode(_component_b_button_group, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_dropdown, {
                                                        variant: "outline-secondary dots",
                                                        size: "sm",
                                                        onClick: ($event) => (_ctx.edit(item))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.edit(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                                                        _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]),
                                                            _cache[19] || (_cache[19] = _createTextVNode()),
                                                            _createVNode(_component_b_dropdown_divider),
                                                            _cache[20] || (_cache[20] = _createTextVNode()),
                                                            _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.archive(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                                                        _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Archive\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]), [
                                                                [_vShow, !item.whenDeleted]
                                                            ]),
                                                            _cache[21] || (_cache[21] = _createTextVNode()),
                                                            _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.restore(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                                                        _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]), [
                                                                [_vShow, item.whenDeleted]
                                                            ])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _cache[22] || (_cache[22] = _createTextVNode()),
                                        _createElementVNode("td", null, [
                                            _createVNode(_component_router_link, {
                                                to: { name: 'application', params: { 'id': item.applicationId } },
                                                class: "blue"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.applicationName), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                        ]),
                                        _cache[23] || (_cache[23] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.whenLastActiveString(item)), 1 /* TEXT */)
                                    ], 2 /* CLASS */));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _cache[26] || (_cache[26] = _createTextVNode()),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [...(_cache[24] || (_cache[24] = [
                                            _createElementVNode("td", {
                                                class: "text-center",
                                                colspan: "3"
                                            }, [
                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ], -1 /* CACHED */)
                                        ]))]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ]),
                    _cache[27] || (_cache[27] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_b_pagination, {
                            class: "float-end",
                            modelValue: _ctx.query.pageNo,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.query.pageNo) = $event)),
                            "per-page": _ctx.query.pageSize,
                            "total-rows": _ctx.data.recordCount,
                            "hide-ellipsis": true,
                            disabled: _ctx.working
                        }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ])
    ]));
}
